<div class="row justify-content-center">
  <div class="col-12">

    <router-outlet></router-outlet>
  </div>
</div> <!-- / .row -->